import React from 'react';
import { Wordmark } from './Wordmark';
export function Hero() {
  return <section className="min-h-screen flex flex-col items-center justify-center px-6 md:px-12 lg:px-24 max-w-7xl mx-auto pt-20 pb-32 text-center" data-id="element-40" data-mp="ejwknco0ih7u">
      {/* Top metadata — sits high on the page, like the masthead of a journal */}
      <div className="font-mono text-[10px] md:text-xs uppercase tracking-[0.4em] text-ink/50 mb-20 md:mb-28" data-id="element-41" data-mp="4mi3tby6fqf0">
        Est. 2025 <span className="mx-3 text-brass/60" data-id="element-42" data-mp="1285wpmvfbqls">·</span> By Application
        Only
      </div>

      {/* The wordmark — the door to the brand */}
      <Wordmark size="xl" align="center" data-id="element-43" data-mp="sbb2vha3iedu" />

      {/* The primary positioning line, set upright for a more tailored register */}
      <p className="font-serif font-light text-ink/90 text-2xl md:text-3xl lg:text-4xl leading-snug mt-10 md:mt-14 max-w-3xl" data-id="element-44" data-mp="nczt16jsw3vm">
        Your Chief Executive of Health.
      </p>

      {/* Sub-tagline — the protective frame */}
      <p className="font-serif font-light text-ink/70 text-lg md:text-xl lg:text-2xl leading-relaxed mt-6 max-w-2xl" data-id="element-45" data-mp="380vy3velgpc3">
        Those who have built everything deserve a partner who protects it all.
      </p>

      {/* The short brass rule — the deck's visual punctuation */}
      <div className="mt-12 mb-12 h-px w-20 bg-brass" aria-hidden="true" data-id="element-46" data-mp="39b4gqzucrs2e" />

      {/* Supporting line — quiet, declarative, sits beneath the rule */}
      <p className="font-sans text-base md:text-lg font-light text-ink/70 max-w-2xl leading-relaxed" data-id="element-47" data-mp="3ebioshvyf20f">
        A private house built around people who run everything except this.
      </p>

      <a href="https://form.jotform.com/262156242446051" target="_blank" rel="noopener noreferrer" className="cta-link mt-16" data-id="element-48" data-mp="35a2jgojzxq32">
        Begin the Application
        <span className="ml-2 font-serif text-lg leading-none" data-id="element-49" data-mp="2vj7sj6vt22ba">→</span>
      </a>
    </section>;
}